import React from "react";
import InitialPropsContext from "../lib/models/initialPropsContext";
import PageNotFoundError from "../lib/pageNotFoundError";
import EventsPage, { Props } from "../components/magazin/EventsPage";
import { Api } from "../lib/CmsApi";
import PageProps from "../lib/models/pageProps";
export default function Page(props: Props) {
  return <EventsPage {...props} />;
}

Page.getInitialProps = async ({
  api,
  query
}: InitialPropsContext): PageProps<Props> => {
  const page = (query.page && parseInt(query.page as string, 10) - 1) || 0;
  const activeTags =
    (query.tags && (query.tags as string).split(",")) || ([] as string[]);

  const requestQuery: Parameters<Api["listExternalEvents"]>[0] = {
    offset: 0,
    limit: 10000,
    fields: [
      "name",
      "dates",
      "description",
      "organizer",
      "location",
      "ctaHref",
      "tags"
    ]
  };
  if (activeTags.length > 0) {
    requestQuery.tags = {
      eq: activeTags
    };
  }

  const [content, tags, allEvents] = await Promise.all([
    api.loadMagazinEventPage().catch(() => {
      throw new PageNotFoundError();
    }),
    api.listTags().catch(() => ({ total: 0, items: [] })),
    api.listExternalEvents(requestQuery).catch(() => ({ total: 0, items: [] }))
  ]);
  if (!content) throw new PageNotFoundError();

  const now = new Date();
  now.setHours(0, 0, 0, 0);

  if (content.highlightEvent) {
    const highlightD1 = new Date(content.highlightEvent.dates[0].date);
    const highlightD2 = content.highlightEvent.dates[1]
      ? new Date(content.highlightEvent.dates[1].date)
      : undefined;
    if (
      (highlightD2 && highlightD2 < now) ||
      (!highlightD2 && highlightD1 && highlightD1 < now)
    ) {
      content.highlightEvent = null;
    }
  }
  let events = content.highlightEvent
    ? allEvents.items.filter(e => e._id != content.highlightEvent._id)
    : allEvents.items;

  //sort events after the due date
  events.sort((d1, d2) => {
    if (d1.dates[0].date > d2.dates[0].date) return 1;
    if (d1.dates[0].date < d2.dates[0].date) return -1;
    return 0;
  });

  events = events.filter(({ dates }) => {
    const d1 = new Date(dates[0].date);
    const d2 = dates[1] ? new Date(dates[1].date) : undefined;

    return !(d2 && d2 < now) && !(!d2 && d1 && d1 < now);
  });

  const pageProps = {
    content,
    tags,
    totalEvents: events.length,
    events: events.slice(page * 10),
    page,
    activeTags,
    seo: content.seo
  };
  let _pageImages;
  try {
    _pageImages = EventsPage.getImages(pageProps);
  } catch (error) {
    console.error(error);
  }

  return { ...pageProps, _pageImages };
};
